import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import cn from "classnames";
import React from "react";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import styles from "./replace-blueprint-gradient-box-info-container.module.scss";
import { BlueprintsArrayObjectTypes } from "@common/types/blueprint-types";
import { TimezoneDate } from "@src/components/atoms/timezone-date/timezone-date";
import { useI18N } from "@src/language/language-context";

interface ReplaceBlueprintInfoContainerPropTypes {
  isCurrentOrSelected: "current" | "selected";
  icon: string;
  blueprint: BlueprintsArrayObjectTypes;
}

const cssClassName = "replace-blueprint-gradient-box-info-container";

export const ReplaceBlueprintGradientBoxInfoContainer = ({
  isCurrentOrSelected,
  icon,
  blueprint,
}: ReplaceBlueprintInfoContainerPropTypes) => {
  const i18n = useI18N();

  const texts = {
    currentBlueprintAltText: i18n(
      "modules.replaceBlueprintGradientBoxInfoContainer.currentBlueprintAltText",
    ),
    from: i18n("modules.replaceBlueprintGradientBoxInfoContainer.from"),
    by: i18n("modules.replaceBlueprintGradientBoxInfoContainer.by"),
  };

  return (
    <FlexRowContainer horizontalGap={0}>
      <img src={icon} alt={texts.currentBlueprintAltText} />
      <FlexColumnContainer>
        <p
          className={cn(styles[`${cssClassName}__blueprint-info-title`], {
            [styles[`${cssClassName}__blueprint-info-title--gray`]]:
              isCurrentOrSelected === "current",
          })}
        >
          {blueprint.name}
        </p>
        <FlexColumnContainer verticalGap={4}>
          <p
            className={cn(styles[`${cssClassName}__blueprint-info-text`], {
              [styles[`${cssClassName}__blueprint-info-text--gray`]]:
                isCurrentOrSelected === "current",
            })}
          >
            {texts.from} <TimezoneDate date={blueprint.created_at} />
          </p>
          <p
            className={cn(
              styles[`${cssClassName}__blueprint-info-text`],
              styles[`${cssClassName}__blueprint-info-text--gray`],
            )}
          >
            {texts.by} {blueprint.author}
          </p>
        </FlexColumnContainer>
      </FlexColumnContainer>
    </FlexRowContainer>
  );
};
